import request, { ResponseData } from '@/utils/axios';
import { Supply } from '@/types/game';

interface Statement {
  fieldName: string;
  symbol: string;
  value: string | number | string[] | number[];
}

interface Sort {
  fieldName: string;
  symbol: string;
}

interface Page {
  pageSize: number;
  page: number;
}

interface SupplyQueryParams {
  match: {
    op: string;
    statements: Statement[];
  };
  sort: Sort[];
  page: Page;
}

interface CurrentSupplyQueryParams extends SupplyQueryParams {
  currentIdentityId: string;
  identityType: string;
}

interface ExternalProductQueryParams {
  match: {
    op: string;
    statements: Statement[];
  };
  sort: Sort[];
}

interface CommodityContent {
  coin: {
    amount: number;
  };
  currency: {
    amount: number;
  };
}

interface Commodity {
  id: string;
  content: CommodityContent;
}

export interface ExternalProduct {
  id: string;
  type: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  commodities: Commodity[];
  signatures: { [key: string]: string };
  status: number;
  createTime: string;
  updateTime: string;
}

// 响应数据类型定义
export interface SupplyQueryResponse {
  code: number;
  message: string;
  data: Supply[];
  total: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
}

// API endpoints
export const MC_API_ENDPOINTS = {
  SUPPLY: {
    COUNT: {
      ANONYMITY: '/mc/supply/count'
    },
    QUERY: {
      ANONYMITY: '/mc/supply/query/anonymity',
      CURRENT: '/mc/supply/query/current'
    }
  },
  EXTERNAL: {
    QUERY: '/mc/external/query'
  }
} as const;

// Export type
export type McApiEndpoints = typeof MC_API_ENDPOINTS;

// Market Center API
export const mcApi = {
  // 剧本供应查询
  supply: {
    query: (params: SupplyQueryParams): Promise<ResponseData<SupplyQueryResponse>> => {
      return request({
        url: MC_API_ENDPOINTS.SUPPLY.QUERY.ANONYMITY,
        method: 'POST',
        data: params
      });
    },
    queryCurrent: (params: CurrentSupplyQueryParams): Promise<ResponseData<SupplyQueryResponse>> => {
      return request({
        url: MC_API_ENDPOINTS.SUPPLY.QUERY.CURRENT,
        method: 'POST',
        data: params
      });
    }
  },

  // 外部商品查询
  external: {
    query: (params: ExternalProductQueryParams): Promise<ResponseData<ExternalProduct[]>> => {
      return request({
        url: MC_API_ENDPOINTS.EXTERNAL.QUERY,
        method: 'POST',
        data: params
      });
    }
  }
};

export type { Commodity, CommodityContent };
export default mcApi; 
